import React, { Component } from "react";
import { RoutedViewProps } from "@my-dld/utils/UrlUtils";
import Strings from "@my-dld/assets/strings";
import { LocaleUtil, StringUtil } from "@eres/core";
import { LocaleValue } from "@eres/core/dist/LocaleValue";
import * as SSO from "@10x/sso";
import { eidFormat, hideLoading, showErrorMessage, showLoading } from "@my-dld/utils/UIUtils";
import { emailF, phoneNumber, picCache, toMobileX } from "./index";
import TextInputField from "@my-dld/components/Form/TextInputField";
import { JQModal } from "@my-dld/components/Popup/Utils";
import { Entities, ProfileApi } from "@10x/dubai-rest-api";
import { ProfileUpdate, UpdateRequest } from "@10x/dubai-rest-api/dist/profile/entity";
import { replaceNavigate } from "@my-dld/utils/StoreUtils";
import PageContent from "@my-dld/components/PageContent";
import Popup from "@my-dld/components/Popup/Popup";
import VerifyPopup from "./VerifyPopup";
import PageTitle from "@my-dld/components/PageTitle";
import { DashboardBCItem, MyProfileBCItem } from "@my-dld/contexts/PageContext";
import PicPopup from "./PicPopup";
import { trackEventWithData } from "@my-dld/utils/Analytics";
import { FixedMobileInput } from "@my-dld/components/FixedEidInput";
import { TabuProfile, TabuVIPCategory } from "@10x/sso/TabuProfile";
import { SSOApi } from "@eres/ssoapi";
import { exToMessage } from "@eres/ssoapi/api";
import { ProfileUpdateResponse } from "@eres/ssoapi/entities";
import SSOVerifyPopup from "./SSOVerifyPopup";
import { getVIPCategory, setSSOUser } from "@my-dld/utils/User";
import { StringsWithPrefix } from "@my-dld/utils/Utils";
import { getOwnerVIPCategoryLabel } from "@my-dld/components/VIPOwner/ContactManager";
import { ProfileImage } from "@my-dld/components/ProfileImage";

interface Props extends RoutedViewProps {

}

interface State {
	name: LocaleValue;
	email: string;
	oemail: string;
	mobile: string;
	omobile: string;
	eid: string;
	agree: boolean;
	error: { [ k: string ]: string };
	updateRsp?: UpdateRequest | ProfileUpdateResponse;
	isMobile?: boolean;
	isEmail?: boolean;
	showPicUpdate: boolean;
	isTabuProfile?: boolean;
	vipCategory?: TabuVIPCategory;
}

export default class EditMyProfile extends Component<Props, State> {
	constructor( props: Props ) {
		super( props );
		let mobile = phoneNumber();
		if ( mobile && !StringUtil.isEmptyStringOrNull( mobile ) ) {
			mobile = toMobileX( mobile );
		}
		this.state = {
			name: SSO.getName()!,
			email: emailF(),
			oemail: emailF(),
			mobile: mobile,
			omobile: mobile,
			eid: eidFormat( SSO.getEmiratesID() ),
			error: {},
			agree: false,
			showPicUpdate: false,
			isTabuProfile: TabuProfile.getProfile() != undefined,
			vipCategory: getVIPCategory(),
		};
	}

	render() {
		const { name, mobile, eid, email, agree, isTabuProfile, vipCategory } = this.state;
		let terms: string[] = [];
		if ( !isTabuProfile ) {
			terms = StringsWithPrefix( "sso_profile_update_tc_" );
		}
		return <React.Fragment>
			<PageContent title={ Strings.edit_profile } hideQLinks={false}>
				<PageTitle title={ Strings.edit_profile } paths={ [ DashboardBCItem, MyProfileBCItem ] }/>
                <div className="card mydld-profile">
                    <a className="position-relative profile-img-link" onClick={this.showPicUpdate}>
                        <ProfileImage />
                        {window.AppInfo && window.AppInfo.config && window.AppInfo.config.uploadPic &&
                            <i className={"fa fa-camera profile-camera-icon"} />
                        }
                    </a>
                    <div className="flex-grid mb-0">
                        <div>
                            <span>{Strings.name} :</span>
                            <span>{LocaleUtil.getLocalValue(name)}</span>
                        </div>
                        {vipCategory && <div>
                            <span>{Strings.category} :</span>
                            <span>{getOwnerVIPCategoryLabel(vipCategory!.CategoryId)}</span>
                        </div>}
                        <div>
                            <span>{Strings.emirates_id} :</span>
                            <span>{eid}</span>
                        </div>
                        <div>
                            <span>{Strings.email} :</span>
                            <span>
                                <TextInputField
                                    containerClassName={"w-100"}
                                    noLabel={true}
                                    id={"email"}
                                    holder={this}
                                    error={this.state.error.email}
                                    placeHolder={Strings.email}
                                    inputClassName={"form-control"}
                                />
                            </span>
                        </div>
                        <div>
                            <span>{Strings.Mobile_text} :</span>
                            <span>
                                <FixedMobileInput
                                    containerClassName={"w-100"}
                                    noLabel={true}
                                    id={"mobile"}
                                    holder={this}
                                    error={this.state.error.mobile}
                                    placeHolder={"+971-5X-XXXXXXX"}
                                    inputClassName={"form-control ltr-text-field"}
                                />
                            </span>
                        </div>
                    </div>
				</div>


				{ !isTabuProfile &&
					<div className="mt-3 mb-3 update-profile-warning-container alert alert-warning">
						<i className={ "icon-warning" }/>
						<div className="update-profile-warning-text">{ Strings.update_sso_profile_warning }</div>
					</div>
                }
                <div className="form-check">
                    <input className="form-check-input" type="checkbox" checked={agree} id="IAgreeOwner" onChange={ event => {
							this.setState( {
								agree: event.target.checked
							} );
						} }/>
                    <label className="form-check-label" htmlFor="IAgreeOwner">
                        {Strings.i_agree_to} <a
                            onClick={this.showAgreement}
                            className="link-unerline">{Strings.terms_and_conditions}</a>
                        </label>
                </div>
				<div className="mb-5 mt-3">
					<button
						className={ "btn btn_1 me-2 " + ( agree ? "" : "disabled" ) }
						type="submit"
						onClick={ this.onUpdate }>{ Strings.update }
					</button>
					<a
						href="#" className="btn btn-grey text-decoration-none" onClick={ e => {
						e.preventDefault();
						this.props.history.goBack();
					} }>{ Strings.cancel }</a>
				</div>
			</PageContent>
			<Popup
				id={ "agreement" }
				showIcon={ false }
				title={ Strings.terms_and_conditions }>
				{ isTabuProfile &&
					Strings.update_profile_agreement
				}
				{ !isTabuProfile &&
					<React.Fragment>
						<ul>
							{ terms.map( ( value, index ) => {
								return <li key={ index }>{ value }</li>;
							} ) }
						</ul>
					</React.Fragment>
				}
			</Popup>
			{ this.state.updateRsp && this.state.isTabuProfile &&
				<VerifyPopup
					mobile={ this.state.isMobile ? this.state.mobile : undefined }
					email={ this.state.isEmail ? this.state.email : undefined }
					resp={ this.state.updateRsp as UpdateRequest }
					requestId={ ( this.state.updateRsp as UpdateRequest )?.RequestId }
					onUserVerified={ this.onVerified }
					onDismiss={ () => this.setState( { updateRsp: undefined } ) }/> }
			{ this.state.updateRsp && this.state.isTabuProfile === false &&
				<SSOVerifyPopup
					mobile={ this.state.isMobile ? this.state.mobile : undefined }
					email={ this.state.isEmail ? this.state.email : undefined }
					onUserVerified={ this.onVerified }
					onDismiss={ () => this.setState( { updateRsp: undefined } ) }/> }
			{ this.state.showPicUpdate && <PicPopup onDismiss={ this.onPicUpdateDismissed }/> }
		</React.Fragment>;
	}

	onPicUpdateDismissed = () => {
		picCache.update();
		this.setState( {
			showPicUpdate: false,
		} );
	};
	showPicUpdate = () => {
		this.setState( {
			showPicUpdate: true
		} );
	};
	onVerified = () => {
		const update: SSO.ProfileUpdate = {};
		if ( this.state.isMobile ) update.mobile = this.state.mobile;
		if ( this.state.isEmail ) update.email = this.state.email;
		if ( this.state.isTabuProfile ) {
			SSO.updateProfile( update );
			showLoading();
			setTimeout( () => {
				hideLoading();
				replaceNavigate( "/mydld/profile" );
			}, 2000 );
		} else {
			showLoading();
			SSOApi.silentTokenRefresh( profile => {
				setSSOUser( profile );
				hideLoading();
				replaceNavigate( "/mydld/profile" );
			}, error => {
				hideLoading();
				replaceNavigate( "/mydld/profile" );
			} );
		}

	};
	onUpdate = () => {
		let { mobile, email, oemail, omobile, agree } = this.state;
		if ( !agree ) return;
		const error: { [ k: string ]: string } = {};
		let isValid = true;
		if ( StringUtil.isEmptyStringOrNull( mobile ) ) {
			error.mobile = Strings.invalid_mobile_number;
			isValid = false;
		}
		if ( StringUtil.isEmptyStringOrNull( email ) ) {
			error.email = Strings.invalid_email_address;
			isValid = false;
		}
		if ( isValid ) {
			const updatedMobile = StringUtil.normaliseMobileNumber( mobile! );

			if ( !isUAEPhoneFormat( updatedMobile ) ) {
				isValid = false;
				error.mobile = Strings.enter_uae_phone_number;
			}
			if ( !StringUtil.isEmailAddress( email! ) ) {
				isValid = false;
				error.email = Strings.invalid_email_address;
			}
			if ( isValid ) {
				let isMobileChange = updatedMobile !== StringUtil.normaliseMobileNumber( omobile! );
				let isEmailChange = email !== oemail;
				if ( isMobileChange || isEmailChange ) {

					let request: ProfileUpdate = {
						email: isEmailChange ? email : undefined,
						mobile: isMobileChange ? updatedMobile : undefined,
					};
					trackEventWithData( "Profile", "TryUpdate", request );
					let api: IUpdateAPI | undefined = undefined;
					if ( this.state.isTabuProfile ) {
						api = TabuProfileUpdate;
					} else
						api = SSOProfileUpdate;
					if ( api ) {
						showLoading();
						api( request ).then( r => {
							hideLoading();
							this.setState( {
								isMobile: isMobileChange,
								isEmail: isEmailChange,
								updateRsp: r,
							}, () => {

							} );
						} )
						.catch( e => {
							hideLoading();
							showErrorMessage( e.toString() );
							trackEventWithData( "Profile", "TryUpdateFailed", { reason: e.toString(), ...request } );
						} );
					}
				} else {
					showErrorMessage( Strings.update_diff_mobile_email );
				}
			}
		}
		this.setState( {
			error: error,
		} );
	};

	showAgreement = ( e: React.MouseEvent ) => {
		e.preventDefault();
		JQModal( "agreement" ).show();
	};
}

interface IUpdateAPI {
	( update: ProfileUpdate ): Promise<UpdateRequest | ProfileUpdateResponse>;
}

const TabuProfileUpdate: IUpdateAPI = ( update: ProfileUpdate ) => {
	return ProfileApi.initProfileUpdate( update )
	.then( Entities.validateResponseX );
};

const SSOProfileUpdate: IUpdateAPI = ( update: ProfileUpdate ) => {
	return SSOApi.profile.initUpdate( update )
	.then( x => x.data )
	.catch( e => {
		return exToMessage( e ).then( msg => {
			throw  msg.error;
		} );
	} );
};

function isUAEPhoneFormat( phone: string ) {
	if ( phone ) {
		if ( phone.startsWith( "971" ) && phone.length >= 12 ) {
			return true;
		}
	}
	return false;
}

